import { Button, Modal } from "antd";
import refund from 'assets/refund .svg';
import { useUpdatePostPondRefund } from "features/transaction_list/use-cases/update-postpond";
import { useUserContext } from "features/users";
import { Fragment, useState } from "react";

export const RefundModal = ({ isModalOpen, handleModalCancel, postPondData }: any) => {
  const { mutate,isLoading } = useUpdatePostPondRefund();
  const { user } = useUserContext();

  const [selectedRefundMethod, setSelectedRefundMethod] = useState<string>("");

  const handleUpdatePostPond = () => {
    const RefundType = selectedRefundMethod === "wallet" ? 1 : selectedRefundMethod === "original" ? 2 : null;
    const payload = {
      BookingId: postPondData?.booking_id,
      RefundAmount: postPondData?.total_cost,
      RefundType, // 1 for wallet, 2 for original
      RefundStatus:3,
      ApprovedBy:0,
      UserId: user?.user_id
    };
    mutate(payload,{onSuccess:()=>{
        handleModalCancel()
    }});
  };

  return (
    <Fragment>
      <Modal
        open={isModalOpen}
        onCancel={handleModalCancel}
        footer={null}
        width={'480px'}
      >
        <div className="refund_model">
          <div className="refunf_icon">
            <img src={refund} alt="" />
          </div>
          <div className="tile_head">
            <h2>Refund Request</h2>
            <p>Submit your refund amount request of <strong>{postPondData?.total_cost}KD</strong></p>
          </div>

          <div className="refund_label">
            <h5>Please select your refund method:</h5>

            <label className="container_wrap">
              <h3>Suffix Wallet</h3>
              <span>Your amount will be instantly credited to your Suffix Wallet. You can use it for any future event registration with ease.</span>
              <input
                type="radio"
                name="refundMethod"
                value="wallet"
                checked={selectedRefundMethod === "wallet"}
                onChange={(e) => setSelectedRefundMethod(e.target.value)}
              />
              <span className="cstmcheckmark"></span>
            </label>

            <label className="container_wrap">
              <h3>Original Payment Mode</h3>
              <span>If preferred, the amount can be returned to your original payment method. Please allow 7–14 business days for processing.</span>
              <input
                type="radio"
                name="refundMethod"
                value="original"
                checked={selectedRefundMethod === "original"}
                onChange={(e) => setSelectedRefundMethod(e.target.value)}
              />
              <span className="cstmcheckmark"></span>
            </label>
          </div>
          <span>Note: If you don’t already have a Suffix account, one will be created automatically and the credited amount will be available in your wallet.</span>
          <Button className="send_btn" onClick={handleUpdatePostPond}   style={{ cursor: 'pointer' }} loading={isLoading}>
            Send Request
          </Button>
        </div>
      </Modal>
    </Fragment>
  );
};
